module.exports = __webpack_public_path__ + "static/media/icon_12.967430ca.png";